import wNumb from 'wnumb'
import WP_DATA from 'utils/wp_data'
import colors from 'utils/colors'

export const normalCase = str => str.split(/-|\ /g)
  .map(s => (
    s.toLowerCase()
    .split('')
    .map((l, i) => i === 0 ? l.toUpperCase() : l)
    .join(''))
  ).join(' ')

export const timestampFromString = string => Math.round(new Date(string).getTime() / 1000)

export const dateFromTimestamp = ts => {
  const parts = new Date(ts*1000).toUTCString().split(' ')
  const [dOw, d, m, y] = parts
  return `${dOw} ${m} ${d}, ${y}`
}

export const keyExists = (k, obj) => k in obj

export const isDefaultItem = fieldName => Object.keys(WP_DATA.worksheet_data).find(d => d[0] === fieldName)

export const determineColor = num => {
  let sectionTotalColor = 'inherit'
  if (Math.sign(num) > 0) {
    sectionTotalColor = colors.green
  } else if (Math.sign(num) < 0) {
    sectionTotalColor = colors.red
  }
  return sectionTotalColor
}

export const moneyFormat = wNumb({
	mark: '.',
	thousand: ',',
  prefix: '$ ',
  decimals: 2,
});